module.exports = __webpack_public_path__ + "static/media/34DSS3.e31428a4.jpg";